export default __webpack_public_path__ + "static/media/weather-sq.6070fcd8.jpg";